export default __webpack_public_path__ + "static/media/girlFloating.b890b69a.png";